export default {"src":"/_next/static/media/x-logo.065affab.svg","height":56,"width":56};